module.exports = __webpack_public_path__ + "img/animation8.e5e6ff66.png";